import TEST_VARIANTS from './variants.json';

export const TESTS = {
    GDPR: 'ha_gdpr_banner',
    POLYFILL_SERVICE: 'HA_PTA_LANDING_PolyfillService',
    PRE_BRAND_TRANSITION: 'HA_GX_PRE_BRAND_TRANSITION',
    POST_BRAND_TRANSITION: 'HA_GX_POST_BRAND_TRANSITION',
    SLP_TRAFFIC_TEST_AA: 'HA_PTA_LANDING_SLPTrafficTestAA',
    SLP_TOP_X_BEST_META_TITLE_TRAFFIC_TEST:
        'HA_PTA_LANDING_SLPTopXBestMetaTitleTrafficTest',
    BREADCRUMB_IN_HEADER: 'HA_PTA_LANDING_SLPReduceAndRepositionBreadcrumb',
    HA_TYPEAHEAD_LID_SEARCH: 'HA_TYPEAHEAD_LID_SEARCH',
    HA_TYPEAHEAD_TWO_LINE_DISPLAY: 'ha_typeahead_two_line_display_v2',
    SEARCH_FORM_SLP: 'HA_PTA_SEARCHFORM_SLP_V2',
    SEARCH_FORM_MLP: 'HA_PTA_SEARCHFORM_MLP_V2',
    TRIPBOARDS_SAVE_LABEL: 'HA_PTA_LANDING_TripBoardsSaveLabel',
    HA_PTA_HEADER_LOGIN_COPY: 'HA_PTA_HEADER_LOGIN_COPY',
    DYNAMIC_SEO_INTRO_PARAGRAPH: 'HA_PTA_LANDING_SLPDynamicIntroParagraph',
    DYNAMIC_SEO_INTRO_PARAGRAPH_OTHER_POS:
        'VRBO_Landing_SLPDynamicIntroParagraphOtherPOS',
    DYNAMIC_SEO_INTRO_PARAGRAPH_OTHER_POS_TRAFFIC:
        'VRBO_Landing_SLPDynamicIntroParagraphOtherPOSTrafficTest', // 39809
    DYNAMIC_RENDERING_2: 'HA_PTA_LANDING_DynamicRenderingIteration2',
    FAMILY_FRIENDLY_MODE: 'HA_PTA_LANDING_SLPFamilyFriendlyListings',
    PILL_FILTER_DESIGN: 'HA_PTA_Landing_Filterdesign',
    NO_GEO_FENCE_SEARCH_HISTORY: 'HA_PTA_LANDING_NoGeoFenceSearchHistorySLP',
    SERVER_SIDE_REVIEWS: 'HA_PTA_LANDING_SLPServerSideReviews',
    SERVER_SIDE_REVIEWS_TRAFFIC:
        'HA_PTA_LANDING_SLPServerSideReviewsTrafficTest',
    SEARCH_FORM_SLP_DATE_PICKER_OPENED:
        'HA_PTA_SEARCHFORM_SLP_Datepickeropened',
    HA_PTA_LANDING_SLP_H2_HEADINGS: 'HA_PTA_LANDING_SLPH2Headings',
    HA_PTA_LANDING_SLPHEROMAB: 'HA_PTA_LANDING_SLPHEROMAB', // 36217
    HA_PTA_SEARCHBOX_HINTTEXTCHOOSINGDATES:
        'HA_PTA_SEARCHBOX_hintTextChoosingDates', // 36021
    VRBO_LANDING_ColourContrastOnSearchForm:
        'VRBO_LANDING_colourContrastOnSearchForm', // 39456
    VRBO_LANDING_SLP_POI_ON_MAP: 'Vrbo_landing_SLPPOIONMAP',
    HEADING_CONVERSION: 'VRBO_LANDING_SLPHeadingConversionTestTemplate',
    HEADING_TRAFFIC: 'VRBO_LANDING_SLPHeadingTrafficTestTemplate',
    CONTENT_HUB_SLP: 'HA_PTA_LANDING_SLPContentHub',
    CONTENT_HUB_SLP_TRAFFIC: 'VRBO_LANDING_SLPContentHubTrafficTest',
    VRBO_WEB_GLOBAL_MESSAGING_BANNER: 'vrbo_web_global_messaging_banner',
    VRBO_WEB_GLOBAL_MESSAGING_ALERT: 'vrbo_web_global_messaging_alert', // 38174
    HA_PTA_SEARCHBOX_AddAgeOfChildren: 'HA_PTA_SEARCHBOX_addAgeOfChildren', // 36244
    HA_PTA_SEARCHBOX_AddBedroomFilter: 'HA_PTA_SEARCHBOX_AddBedroomFilter', // 36212
    HA_TRAVELER_HEADER_TRAY_MOBILE_APP: 'HA_TRAVELER_HEADER_TRAY_MOBILE_APP',
    ESPERANTO_HEADING_CONVERSION: 'VRBO_LANDING_SLPH1Esperanto',
    ESPERANTO_HEADING_TRAFFIC: 'VRBO_LANDING_EsperantoHeadingsTrafficTest',
    USE_TCS_HERO: 'vrbo_landing_TCSforSLPHero', // 39167
    ROADTRIPS_SITE_NAVIGATION: 'VRBO_LANDING_RoadTripsSiteNavigation', // 38445
    ROADTRIPS_SITE_NAVIGATION_NEW_LABEL:
        'VRBO_LANDING_RoadTripsSiteNavigationNewLabel', // 40362
    SLPMODALOPTIMIZATION: 'Vrbo_landing_slpmodaloptimisation', // 39701
    VRBO_LANDING_SLPAA: 'Vrbo_landing_SLPAA', // 39889,
    DISCOVERY_SITE_NAVIGATION: 'HA_PTA_Landing_HPNavigationBar', // 35830
};

export const EVALUATE = [
    TESTS.GDPR,
    TESTS.POLYFILL_SERVICE,
    TESTS.PRE_BRAND_TRANSITION,
    TESTS.POST_BRAND_TRANSITION,
    TESTS.BREADCRUMB_IN_HEADER,
    TESTS.HA_TYPEAHEAD_LID_SEARCH,
    TESTS.HA_TYPEAHEAD_TWO_LINE_DISPLAY,
    TESTS.SEARCH_FORM_SLP,
    TESTS.SEARCH_FORM_MLP,
    TESTS.TRIPBOARDS_SAVE_LABEL,
    TESTS.HA_PTA_HEADER_LOGIN_COPY,
    TESTS.DYNAMIC_SEO_INTRO_PARAGRAPH,
    TESTS.DYNAMIC_SEO_INTRO_PARAGRAPH_OTHER_POS,
    TESTS.DYNAMIC_RENDERING_2,
    TESTS.FAMILY_FRIENDLY_MODE,
    TESTS.PILL_FILTER_DESIGN,
    TESTS.NO_GEO_FENCE_SEARCH_HISTORY,
    TESTS.SEARCH_FORM_SLP_DATE_PICKER_OPENED,
    TESTS.HA_PTA_LANDING_SLP_H2_HEADINGS,
    TESTS.HA_PTA_LANDING_SLPHEROMAB,
    TESTS.HA_PTA_SEARCHBOX_HINTTEXTCHOOSINGDATES,
    TESTS.VRBO_LANDING_ColourContrastOnSearchForm,
    TESTS.VRBO_LANDING_SLP_POI_ON_MAP,
    TESTS.HEADING_CONVERSION,
    TESTS.CONTENT_HUB_SLP,
    TESTS.CONTENT_HUB_SLP_TRAFFIC,
    TESTS.VRBO_WEB_GLOBAL_MESSAGING_BANNER,
    TESTS.VRBO_WEB_GLOBAL_MESSAGING_ALERT,
    TESTS.HA_PTA_SEARCHBOX_AddAgeOfChildren,
    TESTS.HA_PTA_SEARCHBOX_AddBedroomFilter,
    TESTS.HA_TRAVELER_HEADER_TRAY_MOBILE_APP,
    TESTS.SERVER_SIDE_REVIEWS,
    TESTS.SERVER_SIDE_REVIEWS_TRAFFIC,
    TESTS.ESPERANTO_HEADING_CONVERSION,
    TESTS.USE_TCS_HERO,
    TESTS.ROADTRIPS_SITE_NAVIGATION,
    TESTS.ROADTRIPS_SITE_NAVIGATION_NEW_LABEL,
    TESTS.SLPMODALOPTIMIZATION,
    TESTS.VRBO_LANDING_SLPAA,
    TESTS.DISCOVERY_SITE_NAVIGATION,
];

export const hasTest = (abacus, test) => !!(abacus && abacus[test]);

export const getValue = (abacus, test) => {
    const testExists = hasTest(abacus, test);
    if (!testExists) {
        console.warn(`requested value for non-existent test: ${test}`); // eslint-disable-line no-console
    }
    return testExists ? abacus[test].value : null;
};

function withValueFrom(coll, key, op) {
    if (coll.hasOwnProperty(key)) {
        const v = coll[key];
        if (v !== null) {
            return op(v);
        }
    }
    return null;
}

export const getVariant = (abacus, testName) =>
    withValueFrom(TEST_VARIANTS, testName, (testData) =>
        withValueFrom(abacus, testData.key, (abData) =>
            withValueFrom(testData.variants, abData.value, (x) => x)
        )
    );
